"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/card-details.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fcard-details.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardShippingShipmentServiceToJSON = exports.cardShippingShipmentServiceFromJSON = exports.cardShippingStatusToJSON = exports.cardShippingStatusFromJSON = exports.cardProgramTypeToJSON = exports.cardProgramTypeFromJSON = exports.cardReplacementReasonToJSON = exports.cardReplacementReasonFromJSON = exports.cardStatusToJSON = exports.cardStatusFromJSON = exports.cardTypeToJSON = exports.cardTypeFromJSON = exports.CardShipping = exports.CardShippingShipmentService = exports.CardShippingStatus = exports.CardProgramType = exports.CardReplacementReason = exports.CardStatus = exports.CardType = void 0;
const address_1 = require("./address");
const protobufPackage = 'com.step.common.proto';
/**
 * Card type.
 */
var CardType;
(function (CardType) {
    CardType["INVALID_CARD_TYPE"] = "INVALID_CARD_TYPE";
    CardType["VIRTUAL"] = "VIRTUAL";
    CardType["PHYSICAL"] = "PHYSICAL";
    CardType["WALLET"] = "WALLET";
    CardType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardType || (exports.CardType = CardType = {}));
/**
 * Card status.
 */
var CardStatus;
(function (CardStatus) {
    CardStatus["INVALID_CARD_STATUS"] = "INVALID_CARD_STATUS";
    CardStatus["INACTIVE"] = "INACTIVE";
    CardStatus["ACTIVE_WALLET_ONLY"] = "ACTIVE_WALLET_ONLY";
    CardStatus["ACTIVE"] = "ACTIVE";
    CardStatus["CANCELED"] = "CANCELED";
    CardStatus["LOST"] = "LOST";
    CardStatus["STOLEN"] = "STOLEN";
    CardStatus["PENDING"] = "PENDING";
    CardStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardStatus || (exports.CardStatus = CardStatus = {}));
/**
 * Card replacement reason
 */
var CardReplacementReason;
(function (CardReplacementReason) {
    CardReplacementReason["INVALID_CARD_REPLACEMENT_REASON"] = "INVALID_CARD_REPLACEMENT_REASON";
    CardReplacementReason["DAMAGE"] = "DAMAGE";
    CardReplacementReason["EXPIRATION"] = "EXPIRATION";
    CardReplacementReason["LOSS"] = "LOSS";
    CardReplacementReason["THEFT"] = "THEFT";
    CardReplacementReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardReplacementReason || (exports.CardReplacementReason = CardReplacementReason = {}));
/**
 * Card program type.
 */
var CardProgramType;
(function (CardProgramType) {
    CardProgramType["INVALID_CARD_PROGRAM_TYPE"] = "INVALID_CARD_PROGRAM_TYPE";
    CardProgramType["DEFAULT"] = "DEFAULT";
    CardProgramType["STEP_BLACK"] = "STEP_BLACK";
    CardProgramType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardProgramType || (exports.CardProgramType = CardProgramType = {}));
var CardShippingStatus;
(function (CardShippingStatus) {
    CardShippingStatus["INVALID_CARD_SHIPPING_STATUS"] = "INVALID_CARD_SHIPPING_STATUS";
    CardShippingStatus["PENDING"] = "PENDING";
    CardShippingStatus["SHIPPED"] = "SHIPPED";
    CardShippingStatus["DELIVERED"] = "DELIVERED";
    CardShippingStatus["RETURNED"] = "RETURNED";
    CardShippingStatus["FAILURE"] = "FAILURE";
    CardShippingStatus["CANCELED"] = "CANCELED";
    CardShippingStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardShippingStatus || (exports.CardShippingStatus = CardShippingStatus = {}));
var CardShippingShipmentService;
(function (CardShippingShipmentService) {
    CardShippingShipmentService["INVALID_SHIPMENT_SERVICE"] = "INVALID_SHIPMENT_SERVICE";
    /**
     * STANDARD - Cards arrive in 5-8 business days.
     */
    CardShippingShipmentService["STANDARD"] = "STANDARD";
    /**
     * EXPRESS - Cards arrive in 4 business days.
     */
    CardShippingShipmentService["EXPRESS"] = "EXPRESS";
    /**
     * PRIORITY - Cards arrive in 2-3 business days.
     */
    CardShippingShipmentService["PRIORITY"] = "PRIORITY";
    CardShippingShipmentService["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardShippingShipmentService || (exports.CardShippingShipmentService = CardShippingShipmentService = {}));
function createBaseCardShipping() {
    return {
        status: CardShippingStatus.INVALID_CARD_SHIPPING_STATUS,
        carrier: '',
        trackingNumber: '',
        trackingUrl: '',
        service: CardShippingShipmentService.INVALID_SHIPMENT_SERVICE,
        address: undefined,
        etaMs: '0',
    };
}
exports.CardShipping = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.status)) {
            message.status = cardShippingStatusFromJSON(object.status);
        }
        if (isSet(object.carrier)) {
            message.carrier = globalThis.String(object.carrier);
        }
        if (isSet(object.trackingNumber)) {
            message.trackingNumber = globalThis.String(object.trackingNumber);
        }
        if (isSet(object.trackingUrl)) {
            message.trackingUrl = globalThis.String(object.trackingUrl);
        }
        if (isSet(object.service)) {
            message.service = cardShippingShipmentServiceFromJSON(object.service);
        }
        if (isSet(object.address)) {
            message.address = address_1.Address.fromJSON(object.address);
        }
        if (isSet(object.etaMs)) {
            message.etaMs = globalThis.String(object.etaMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== undefined &&
            message.status !== CardShippingStatus.INVALID_CARD_SHIPPING_STATUS) {
            obj.status = cardShippingStatusToJSON(message.status);
        }
        if (message.carrier !== undefined && message.carrier !== '') {
            obj.carrier = message.carrier;
        }
        if (message.trackingNumber !== undefined && message.trackingNumber !== '') {
            obj.trackingNumber = message.trackingNumber;
        }
        if (message.trackingUrl !== undefined && message.trackingUrl !== '') {
            obj.trackingUrl = message.trackingUrl;
        }
        if (message.service !== undefined &&
            message.service !== CardShippingShipmentService.INVALID_SHIPMENT_SERVICE) {
            obj.service = cardShippingShipmentServiceToJSON(message.service);
        }
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        if (message.etaMs !== undefined && message.etaMs !== '0') {
            obj.etaMs = message.etaMs;
        }
        return obj;
    },
    create(base) {
        return exports.CardShipping.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardShipping();
        message.status = object.status ?? CardShippingStatus.INVALID_CARD_SHIPPING_STATUS;
        message.carrier = object.carrier ?? '';
        message.trackingNumber = object.trackingNumber ?? '';
        message.trackingUrl = object.trackingUrl ?? '';
        message.service = object.service ?? CardShippingShipmentService.INVALID_SHIPMENT_SERVICE;
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : undefined;
        message.etaMs = object.etaMs ?? '0';
        return message;
    },
};
function cardTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CARD_TYPE':
            return CardType.INVALID_CARD_TYPE;
        case 1:
        case 'VIRTUAL':
            return CardType.VIRTUAL;
        case 2:
        case 'PHYSICAL':
            return CardType.PHYSICAL;
        case 3:
        case 'WALLET':
            return CardType.WALLET;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardType.UNRECOGNIZED;
    }
}
exports.cardTypeFromJSON = cardTypeFromJSON;
function cardTypeToJSON(object) {
    switch (object) {
        case CardType.INVALID_CARD_TYPE:
            return 'INVALID_CARD_TYPE';
        case CardType.VIRTUAL:
            return 'VIRTUAL';
        case CardType.PHYSICAL:
            return 'PHYSICAL';
        case CardType.WALLET:
            return 'WALLET';
        case CardType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardTypeToJSON = cardTypeToJSON;
function cardStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CARD_STATUS':
            return CardStatus.INVALID_CARD_STATUS;
        case 1:
        case 'INACTIVE':
            return CardStatus.INACTIVE;
        case 7:
        case 'ACTIVE_WALLET_ONLY':
            return CardStatus.ACTIVE_WALLET_ONLY;
        case 2:
        case 'ACTIVE':
            return CardStatus.ACTIVE;
        case 3:
        case 'CANCELED':
            return CardStatus.CANCELED;
        case 4:
        case 'LOST':
            return CardStatus.LOST;
        case 5:
        case 'STOLEN':
            return CardStatus.STOLEN;
        case 6:
        case 'PENDING':
            return CardStatus.PENDING;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardStatus.UNRECOGNIZED;
    }
}
exports.cardStatusFromJSON = cardStatusFromJSON;
function cardStatusToJSON(object) {
    switch (object) {
        case CardStatus.INVALID_CARD_STATUS:
            return 'INVALID_CARD_STATUS';
        case CardStatus.INACTIVE:
            return 'INACTIVE';
        case CardStatus.ACTIVE_WALLET_ONLY:
            return 'ACTIVE_WALLET_ONLY';
        case CardStatus.ACTIVE:
            return 'ACTIVE';
        case CardStatus.CANCELED:
            return 'CANCELED';
        case CardStatus.LOST:
            return 'LOST';
        case CardStatus.STOLEN:
            return 'STOLEN';
        case CardStatus.PENDING:
            return 'PENDING';
        case CardStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardStatusToJSON = cardStatusToJSON;
function cardReplacementReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CARD_REPLACEMENT_REASON':
            return CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON;
        case 1:
        case 'DAMAGE':
            return CardReplacementReason.DAMAGE;
        case 2:
        case 'EXPIRATION':
            return CardReplacementReason.EXPIRATION;
        case 3:
        case 'LOSS':
            return CardReplacementReason.LOSS;
        case 4:
        case 'THEFT':
            return CardReplacementReason.THEFT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardReplacementReason.UNRECOGNIZED;
    }
}
exports.cardReplacementReasonFromJSON = cardReplacementReasonFromJSON;
function cardReplacementReasonToJSON(object) {
    switch (object) {
        case CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON:
            return 'INVALID_CARD_REPLACEMENT_REASON';
        case CardReplacementReason.DAMAGE:
            return 'DAMAGE';
        case CardReplacementReason.EXPIRATION:
            return 'EXPIRATION';
        case CardReplacementReason.LOSS:
            return 'LOSS';
        case CardReplacementReason.THEFT:
            return 'THEFT';
        case CardReplacementReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardReplacementReasonToJSON = cardReplacementReasonToJSON;
function cardProgramTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CARD_PROGRAM_TYPE':
            return CardProgramType.INVALID_CARD_PROGRAM_TYPE;
        case 1:
        case 'DEFAULT':
            return CardProgramType.DEFAULT;
        case 2:
        case 'STEP_BLACK':
            return CardProgramType.STEP_BLACK;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardProgramType.UNRECOGNIZED;
    }
}
exports.cardProgramTypeFromJSON = cardProgramTypeFromJSON;
function cardProgramTypeToJSON(object) {
    switch (object) {
        case CardProgramType.INVALID_CARD_PROGRAM_TYPE:
            return 'INVALID_CARD_PROGRAM_TYPE';
        case CardProgramType.DEFAULT:
            return 'DEFAULT';
        case CardProgramType.STEP_BLACK:
            return 'STEP_BLACK';
        case CardProgramType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardProgramTypeToJSON = cardProgramTypeToJSON;
function cardShippingStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CARD_SHIPPING_STATUS':
            return CardShippingStatus.INVALID_CARD_SHIPPING_STATUS;
        case 1:
        case 'PENDING':
            return CardShippingStatus.PENDING;
        case 2:
        case 'SHIPPED':
            return CardShippingStatus.SHIPPED;
        case 3:
        case 'DELIVERED':
            return CardShippingStatus.DELIVERED;
        case 4:
        case 'RETURNED':
            return CardShippingStatus.RETURNED;
        case 5:
        case 'FAILURE':
            return CardShippingStatus.FAILURE;
        case 6:
        case 'CANCELED':
            return CardShippingStatus.CANCELED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardShippingStatus.UNRECOGNIZED;
    }
}
exports.cardShippingStatusFromJSON = cardShippingStatusFromJSON;
function cardShippingStatusToJSON(object) {
    switch (object) {
        case CardShippingStatus.INVALID_CARD_SHIPPING_STATUS:
            return 'INVALID_CARD_SHIPPING_STATUS';
        case CardShippingStatus.PENDING:
            return 'PENDING';
        case CardShippingStatus.SHIPPED:
            return 'SHIPPED';
        case CardShippingStatus.DELIVERED:
            return 'DELIVERED';
        case CardShippingStatus.RETURNED:
            return 'RETURNED';
        case CardShippingStatus.FAILURE:
            return 'FAILURE';
        case CardShippingStatus.CANCELED:
            return 'CANCELED';
        case CardShippingStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardShippingStatusToJSON = cardShippingStatusToJSON;
function cardShippingShipmentServiceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SHIPMENT_SERVICE':
            return CardShippingShipmentService.INVALID_SHIPMENT_SERVICE;
        case 1:
        case 'STANDARD':
            return CardShippingShipmentService.STANDARD;
        case 2:
        case 'EXPRESS':
            return CardShippingShipmentService.EXPRESS;
        case 3:
        case 'PRIORITY':
            return CardShippingShipmentService.PRIORITY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardShippingShipmentService.UNRECOGNIZED;
    }
}
exports.cardShippingShipmentServiceFromJSON = cardShippingShipmentServiceFromJSON;
function cardShippingShipmentServiceToJSON(object) {
    switch (object) {
        case CardShippingShipmentService.INVALID_SHIPMENT_SERVICE:
            return 'INVALID_SHIPMENT_SERVICE';
        case CardShippingShipmentService.STANDARD:
            return 'STANDARD';
        case CardShippingShipmentService.EXPRESS:
            return 'EXPRESS';
        case CardShippingShipmentService.PRIORITY:
            return 'PRIORITY';
        case CardShippingShipmentService.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardShippingShipmentServiceToJSON = cardShippingShipmentServiceToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=card-details.js.map